export const TOOLTIPS_TEXT = {
  DEFAULT_VISIBILITY: 'Столбец виден по умолчанию',
  SUPERVISOR_INVISIBILITY: 'Столбец не виден руководителю',
  PIVOT_SCREEN_VISIBILITY: 'Столбец виден на сводном экране',
};
